import { css, cx } from '@emotion/css';
import { theme } from 'Shared/ThemeProvider';
import { LabelOnRightWrap } from 'Shared/forms/Wrap'
import { Show } from 'solid-js'
import { useStore } from 'Shared/StoreProvider';
import type {Layout} from 'Shared/model/Components';
import { optionList } from 'Shared/backend/widgets/ComponentOptions';
import { splitLocation, subdoc } from 'Common/ViewUtils';
import { useLink } from 'Shared/backend/LinkProvider';
import { Checkbox, Text } from 'Shared/forms/Inputs';
import { traverseComponents } from 'Shared/backend/widgets/traverseComponents';
import { SeparatedComponentAndSelector } from 'Shared/backend/widgets/SeparatedComponentAndSelector';
import { useLayout } from 'Shared/backend/LayoutProvider';

export const detailsStyle = () => css({
	display: 'flex',
	flexDirection: 'column',
	gap: '0.8em',
});


export function Section(P:Layout & {index:number})
{
	const lo = useLayout();
	const sw = useStore();

	const sectionStyle = css({
		padding: '6px 1em 2em 1em',
		border: '1px solid black',
		marginTop: '0.5em'
	});

	const viewWebsiteStyle = css({
		alignSelf: 'flex-end'
	});

	const bottomRowStyle = () => css({
		display: 'flex',
		alignItems: 'center',
		gap: '1em',
		marginTop: lo.layout() ? '1.5em' : '0'
	});

	const cloneLinkStyle = css(theme().a, {
		whiteSpace: 'nowrap'
	});

	const disableWrapStyle = css({
		width: 'unset',
	});

	const options = optionList(['image','vertical','visualWithInfo','posters','slides','grid',],[]);

	return (
		<div class={cx(sectionStyle,detailsStyle())}>
			<div class={detailsStyle()}>
				<Show when={lo.layout()}>
					<Text field='name' placeholder='Section name (optional)' class={css({maxWidth:'20em',alignSelf:'start'})} />
				</Show>

				<SeparatedComponentAndSelector {...P} options={options} isTop />
			</div>

			<div class={bottomRowStyle()}>
				<Show when={lo.layout()}>
					<a class={cloneLinkStyle} href='' onClick={e => cloneSection(e,sw)}>Clone section</a>
				</Show>

				<div style={{'flex-grow':1}} />

				<LabelOnRightWrap class={disableWrapStyle} label='Disable section'>
					<Checkbox field='disable' />
				</LabelOnRightWrap>

				<Show when={P.layout}>
					<a class={viewWebsiteStyle} target='_blank' href={useLink()+'#widget'+P.index}>
						<button class={css(theme().smallButton)}>View on website</button>
					</a>
				</Show>
			</div>
		</div>
	);
}

async function cloneSection(e:Event,sw)
{
	e.preventDefault();
	const section = JSON.parse(JSON.stringify(subdoc(sw.store,sw.location)));

	traverseComponents(section,replaceImagesAndText);

	const [path,index] = splitLocation(sw.location);

	sw.setStore(path, items => [...items,section]);

	await sw.server.createArrayItem.mutate({page:sw.page,permission:sw.permission,id:sw.docId,location:['layout'],fields:section});
}

function replaceImagesAndText(data)
{
	if (data.layout=='text' && data.text)
		data.text = '[COPIED] '+data.text;
	if (data.layout=='image')
		data.image.hash = undefined;
}

